import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue"
import zhCn from 'element-plus/es/locale/lang/zh-cn'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

console.log("process.env", process.env)
if (process.env.VUE_APP_PLATFORM === "electron") {
  localStorage.removeItem("token");
  localStorage.removeItem("token_time");
  localStorage.removeItem("loginInfo");
}
onMounted(() => {
  const heartbeat = sessionStorage.getItem("heartbeat");
  if (!heartbeat) {
    localStorage.removeItem("token");
    localStorage.removeItem("token_time");
    localStorage.removeItem("loginInfo");
  }
  // 执行清理或保存操作
  // localStorage.removeItem("token");
  // localStorage.removeItem("token_time");
  // localStorage.removeItem("loginInfo");
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _unref(zhCn) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})